<template>
  <footer>
    <div class="bg-primary pt-9 lg:pt-16 pb-9 border-t border-white">
      <div class="container">
        <div class="lg:flex">
          <div
            class="w-full lg:flex-[0_0_14%] lg:max-w-[14%] text-center lg:pt-7.5"
          >
            <nuxt-link
              class="hover:opacity-80 inline-block"
              :to="localePath('/')"
            >
              <img
                class="object-contain w-10 lg:w-15"
                :src="settings?.footer_logo"
                :alt="
                  settings?.company_name
                    ? `${settings?.company_name} ${$t('footerLogo')}`
                    : $t('companyLogo')
                "
              />
            </nuxt-link>
          </div>
          <div
            class="w-full lg:flex-[0_0_43%] lg:max-w-[43%] lg:order-first max-lg:mt-8"
          >
            <div class="max-w-[340px] max-lg:mx-auto">
              <CommonSubscriptionFooterForm />
              <CommonFooterSocial class="mt-4" />
            </div>
          </div>
          <div class="w-full flex-[0_0_43%] max-w-[43%] hide-mobile">
            <div class="flex flex-wrap justify-end w-full max-w-full gap-10">
              <div
                v-for="(item, i) in mainFooterMenu"
                :key="`parent_link_${i}`"
                class="ui-text-m text-white break-all lg:max-w-[210px]"
              >
                <template v-if="item.is_title">
                  <div class="ui-text-m font-medium">
                    {{ item?.currentTranslation?.title }}
                  </div>
                </template>

                <template v-else-if="item.url.includes('btn-id-')">
                  <button
                    :id="extractButtonId(item.url)"
                    class="inline-flex cursor-pointer hover:underline ui-text-m font-medium"
                  >
                    {{ item?.currentTranslation?.title }}
                  </button>
                </template>

                <template v-else>
                  <nuxt-link
                    :to="localePath(item.url)"
                    class="ui-text-m font-medium"
                  >
                    {{ item?.currentTranslation?.title }}
                  </nuxt-link>
                </template>
                <ul v-if="item.children?.length" class="mt-4 space-y-1">
                  <li
                    v-for="(link, index) in item.children"
                    :key="`link_${i}_${index}`"
                  >
                    <template v-if="link.is_title">
                      <div class="inline-flex cursor-default">
                        {{ link?.currentTranslation?.title }}
                      </div>
                    </template>

                    <template v-else-if="link.url.includes('btn-id-')">
                      <button
                        :id="extractButtonId(link.url)"
                        class="inline-flex cursor-pointer hover:underline"
                      >
                        {{ link?.currentTranslation?.title }}
                      </button>
                    </template>

                    <template v-else>
                      <nuxt-link
                        :to="localePath(link.url)"
                        class="inline-flex hover:underline"
                      >
                        {{ link?.currentTranslation?.title }}
                      </nuxt-link>
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <CommonFooterMobile class="lg:hidden mt-8" />
        <div
          class="ui-text-xs leading-5 text-white mt-10 lg:mt-7.5"
          v-html="footer.copyright"
        />
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useGeneralInternalStore } from "~/stores/generalInternal";

const localePath = useLocalePathPolyfill();
const { footerMenu, settings } = useGeneralStore();
const { footer } = useGeneralInternalStore();

const mainFooterMenu = computed(() => {
  return toTree(footerMenu);
});
</script>
